import { createFileRoute } from '@tanstack/react-router'
import { SavedQueryProvider, SavedQueryState } from '~/features/saved-query'
import { DEFAULT_INITIAL_VALUE } from '~/features/saved-query/constants'
import { useTitle } from '~/hooks'

import { PivotHeader } from './-components/header'
import { PivotOutput } from './-components/output'
import { PIVOT_OPTIONS_MAP, PivotOptions } from './-components/pivot-options'

const INITIAL_VALUE = {
  ...DEFAULT_INITIAL_VALUE,
  rows: [
    {
      field: 'channelId',
      dataset: 'interactions',
      hydrate: true,
    },
  ],
  columns: [],
  aggregations: [
    ...PIVOT_OPTIONS_MAP.percent_total_interactions.fields,
    ...PIVOT_OPTIONS_MAP.total_interactions.fields,
  ],
} satisfies SavedQueryState['data']['params']

export const Route = createFileRoute('/_authenticated/$alias/_app/reports/pivot/')({
  component: RouteComponent,
})

function RouteComponent() {
  useTitle('Pivot')
  return (
    <SavedQueryProvider
      initialValue={INITIAL_VALUE}
      type="pivot"
      from="/$alias/reports/pivot/"
    >
      <div className="col-span-full my-5 flex h-10 justify-between px-4">
        <PivotHeader />
      </div>
      <div className="flex h-[calc(100vh-131px)] w-full border-t">
        <PivotOutput />
        <div className="w-[300px] shrink-0 border-l px-4">
          <PivotOptions />
        </div>
      </div>
    </SavedQueryProvider>
  )
}
